import { isGemXDevMode } from '~/server/auth/shopify/helpers';
import { useAppBridge } from '@shopify/app-bridge-react';
import { isBrowser } from '~/utils';

export function useSaveBar() {
  if (!isBrowser() || isGemXDevMode()) {
    return {
      shopifySaveBar: {
        show: (_data: any) => {},
        hide: (..._data: any) => {},
        leaveConfirmation: () => {},
      },
    };
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { saveBar } = useAppBridge();

  const show = (id: string) => {
    saveBar.show(id);
  };
  const hide = (id: string) => {
    saveBar.hide(id);
  };
  const leaveConfirmation = () => {
    saveBar.leaveConfirmation();
  };
  return {
    shopifySaveBar: {
      show,
      hide,
      leaveConfirmation,
    },
  };
}
